module.exports = __webpack_public_path__ + "static/img/car_5_2_box@3x.10f2c3ea.png";